<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <v-row no-gutters class="mb-5">
      <v-col cols="12" md="9">
        <h2>{{ prasymasTitle }}</h2>
        <div class="zug-info" v-if="showPraInfo">
          {{ this.prasymas.pra_numeris }}
        </div>
      </v-col>
      <v-col cols="12" md="3" class="text-right">
        <div>
          <el-button v-if="showToList" @click.native="toList()" x-small
            >Grįžti į sąrašą</el-button
          >
        </div>
        <el-busena
          class="mt-2"
          :busena="laukiaPatvirtinimoText"
          v-if="prasymas.laukia_patvirtinimo"
        />
        <el-busena
          class="mt-2"
          busena="Laukia pasirašymo"
          v-if="prasymas.pra_pasirasymas_vadovas"
        />
        <el-prasymas-busena class="mt-2" :busena="prasymasBusenaTitle" />
        <el-busena
          v-if="prasymas.pra_vykdo && roleRG"
          class="mt-2"
          color="green"
          :busena="vykdoText"
        />
      </v-col>
    </v-row>
    <check-errors ntr-paslaugos />
    <template v-if="isLock">
      <v-card>
        <v-card-text>
          <v-alert class="mt-5 mb-5" dense outlined type="error">
            Dokumentas redaguojamas
          </v-alert>
        </v-card-text>
      </v-card>
    </template>
    <template v-if="isLoaded">
      <v-sheet class="d-flex justify-start" color="transparent">
        <v-card flat style="width: 200px;" color="transparent" class="mr-5">
          <v-card>
            <v-list dense>
              <v-list-item-group
                v-model="selectedTab"
                color="primary"
                mandatory
              >
                <v-list-item
                  v-for="(item, i) in filteredTabItems"
                  :key="i"
                  @click="gotoTab(item)"
                >
                  <v-list-item-content>
                    <v-list-item-title :class="tabClass(item)">{{
                      item.title
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-card>
        <v-card v-if="activeTab >= 0" width="100%" :min-width="dataMinWidth">
          <component
            :key="`component-${prasymasID}`"
            :is="tabItems[activeRoute].component"
            :readonly-form="isReadonlyForm"
            :readonly="prasymas.pra_readonly"
            class="tabComponent"
          ></component>
        </v-card>
        <v-card
          v-if="activeTab < 0"
          :min-width="dataMinWidth"
          width="100%"
          class="pa-5"
        >
          <v-alert dense outlined type="error"
            >Neturite teisių matyti šios informacijos.</v-alert
          >
        </v-card>
      </v-sheet>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import UnsavedData from '../modals/UnsavedData'
import CheckErrors from '../hipoteka/CheckErrors'
import unsavedDataRoute from '@/mixins/unsavedDataRoute'
import prasymasTabs from '@/mixins/prasymasTabs'
import NtrPaslaugosMap from '../ntrpaslaugos/NtrPaslaugosMap'
import userRole from '@/mixins/userRole'
import busena from '@/mixins/busenaNtr'

import RegPrasymasDuomenys from './RegPrasymasDuomenys'
import RegPrasymasTeikejas from './RegPrasymasTeikejas'
import RegPrasymasAsmenys from './RegPrasymasAsmenys'
import RegPrasymasTurtas from './RegPrasymasTurtas'
import RegPrasymasSutartis from './RegPrasymasSutartis'
import RegPrasymasSutartisPreliminari from './RegPrasymasSutartisPreliminari'
import RegPrasymasRinkmenos from './RegPrasymasRinkmenos'
import RegPrasymasInformavimas from './RegPrasymasInformavimas'
import RegPrasymasRegistravimas from './RegPrasymasRegistravimas'

export default {
  name: 'PrasymasTab',
  components: { UnsavedData, CheckErrors },
  mixins: [userRole, busena, prasymasTabs, unsavedDataRoute],
  data() {
    return {
      pageloading: true,
      prasymas: {},
    }
  },
  computed: {
    ...mapGetters([
      'prasymasID',
      'prasymasTipas',
      'prasymasBusena',
      'prasymasReadonly',
      'appSavitarna',
      'listInfo',
      'pagrindasKodas',
    ]),
    dataMinWidth() {
      return '800px'
    },
    routeItems() {
      return {
        regPrasymasDuomenys: {
          component: RegPrasymasDuomenys,
          readonly: false,
        },
        regPrasymasTeikejas: {
          component: RegPrasymasTeikejas,
          readonly: false,
        },
        regPrasymasAsmenys: {
          component: RegPrasymasAsmenys,
          readonly: false,
          hide: this.isPrasymasPirmenybe,
        },
        regPrasymasTurtas: {
          component: RegPrasymasTurtas,
          readonly: false,
        },
        regPrasymasAsmenysPirmenybe: {
          component: RegPrasymasAsmenys,
          readonly: false,
          hide: !this.isPrasymasPirmenybe,
        },
        regPrasymasSutartis: {
          component: this.isPrasymasPreliminari
            ? RegPrasymasSutartisPreliminari
            : RegPrasymasSutartis,
          readonly: false,
          hide: !this.showSutartisTab,
        },
        regPrasymasRinkmenos: {
          component: RegPrasymasRinkmenos,
          readonly: this.readonlyPrasymasRinkmenos,
          hide: !this.showRinkmenosTab,
        },
        regPrasymasInformavimas: {
          component: RegPrasymasInformavimas,
          readonly: false,
        },
        regPrasymasRegistravimas: {
          component: RegPrasymasRegistravimas,
          readonly: false,
        },
      }
    },
    filteredRouteItems() {
      return this.routeItems.filter(item => {
        return !item.hide
      })
    },
    tabItems() {
      return Object.entries(this.routeItems).map(([key, item]) => {
        return {
          ...item,
          ...(this.prasymasTabs[key] ?? []),
        }
      })
    },
    filteredTabItems() {
      return this.tabItems.filter(item => {
        return !item.hide
      })
    },
    selectedTab: {
      set(value) {
        // this.activeTab = value
      },
      get() {
        return this.activeTab
      },
    },
    activeTab: {
      set(value) {
        // this.selectedTab = value
      },
      get() {
        return this.filteredTabItems.findIndex(function(item, index) {
          return this.$route.matched.find(element => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.tabItems.findIndex(function(item, index) {
        if (item.route === this.$route.name) {
          return true
        }
      }, this)
    },
    prasymasTitle() {
      return this.prasymas.pra_id
        ? NtrPaslaugosMap.getPrasymasTipas(this.prasymasTipas).title +
            (this.prasymas.pra_dokumento_numeris
              ? ` Nr. ${this.prasymas.pra_dokumento_numeris}`
              : '')
        : ''
    },
    prasymasBusenaTitle() {
      return NtrPaslaugosMap.getPrasymasBusena(this.prasymas.pra_busena).title
    },
    laukiaPatvirtinimoText() {
      return `Laukia ${this.prasymas.pra_registratoriai_aktyvus ??
        ''} patvirtinimo`
    },
    vykdoText() {
      return `Vykdo ${this.prasymas.pra_vykdo ?? ''}`
    },
    isSavitarna() {
      return this.appSavitarna
    },
    isLock() {
      return this.prasymas.pra_uzrakinta
    },
    isLoaded() {
      return !this.isLock && !this.pageloading
    },
    showPraInfo() {
      return this.roleRGV
    },
    showToList() {
      return this.listInfo.pra_id === this.prasymasID
    },
    showSutartisTab() {
      return (
        this.isPrasymasNuoma ||
        this.isPrasymasPanauda ||
        this.isPrasymasSubnuoma ||
        this.isPrasymasPreliminari
      )
    },
    showRinkmenosTab() {
      return (
        !this.isPrasymasPirmenybe ||
        (this.isPrasymasPirmenybe && this.isGrazintas)
      )
    },
    isReadonlyForm() {
      return (
        this.prasymas.pra_readonly ||
        !((this.isRengiamas || this.isGrazintas) && this.roleNotaras)
      )
    },
    readonlyPrasymasRinkmenos() {
      return !this.prasymas.bylos_segamos
    },
  },
  beforeCreate() {
    this.$root.$off('reloadPrasymasTab')
  },
  beforeDestroy() {
    // if (!this.prasymasReadonly) {
    this.$store.dispatch('unlockPra', {
      pra_id: this.prasymasID,
      lock: false,
    })
    // }
  },
  created() {
    this.$root.$on('reloadPrasymasTab', () => {
      this.getData()
    })
    this.$store.dispatch('checkErrors', null)
    this.defaultRouteParams()
    this.getData()
  },
  methods: {
    defaultRouteParams() {
      if (this.$route.params.prasymasID) {
        this.$store.dispatch('prasymasID', this.$route.params.prasymasID)
      }
    },
    getData() {
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/prasymastab`)
        .then(res => {
          this.prasymas = res.data.prasymas

          if (
            this.prasymas.pra_pasirasymas_vadovas &&
            this.prasymas.pra_busena !== 'rengiamas' &&
            this.prasymas.pra_busena !== 'grazintas'
          ) {
            this.prasymas.pra_readonly = true
          }
          if (this.roleSkaitytojas) {
            this.prasymas.pra_readonly = true
          }

          this.$store.dispatch('prasymasSistema', this.prasymas.sistema)
          this.$store.dispatch('prasymasTipas', this.prasymas.pra_tipas)
          this.$store.dispatch('prasymasBusena', this.prasymas.pra_busena)
          this.$store.dispatch(
            'prasymasBusenaTolimesne',
            this.prasymas.pra_busena_tolimesne
          )
          this.$store.dispatch('prasymasReadonly', this.prasymas.pra_readonly)
          this.$store.dispatch('prasymasOwner', this.prasymas.is_owner)

          this.$store.dispatch(
            'pasirasymasVadovas',
            this.prasymas.pra_pasirasymas_vadovas
          )
          this.$store.dispatch('prasymasSignStatus', this.prasymas.sign_status)

          this.$store.dispatch(
            'registratoriaiAktyvus',
            this.prasymas.pra_registratoriai_aktyvus
          )
          this.$store.dispatch('lockPra', {
            pra_id: this.prasymasID,
            lock: !this.pra_readonly,
          })
          this.$store.dispatch('pagrindasKodas', this.prasymas.pagrindas_kodas)
        })
        .catch(err => {
          if (err.response && err.response.status === 404) {
            this.$router.push({ name: 'home' })
          }
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
    tabClass(item) {
      return 'tabItem ' + (item.readonly && !item.forceActive ? 'readonly' : '')
    },
    toList() {
      this.$router.push({
        name: this.listInfo.routeName,
        params: {
          toList: true,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
.tabItem {
  &.readonly {
    color: $secondary;
  }
}
.tabComponent {
  margin: 0 auto 0 0;
}
.zug-info {
  font-size: 0.8rem;
  opacity: 0.8;
}
</style>
